const w = window;

// w.$ used again last to be the return value of the expression
export default () => w.$ && w.jQuery && w.$ === w.jQuery && w.$;
